import { LayoutContext } from '@/layout/context/context';
import type { PopupProps } from '@/types/component';
import {
  AccountSettings,
  defaultDarkModeOverride,
  ThemeProvider,
  type Theme,
} from '@aws-amplify/ui-react';
import { Dialog } from 'primereact/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const ChangePsPopup = ({ open, setOpen }: PopupProps) => {
  const { t } = useTranslation('common');
  const { theme } = useContext(LayoutContext);
  const nav = useNavigate();

  const customTheme: Theme = {
    name: 'custom-theme',
    overrides: [defaultDarkModeOverride],
    tokens: {
      components: {
        authenticator: {
          router: {
            borderWidth: { value: '0px' },
            boxShadow: { value: 'none' },
          },
        },
      },
    },
  };

  return (
    <Dialog
      header={t('Change Password')}
      visible={open}
      onHide={() => setOpen(false)}
      className="w-screen max-w-[500px]"
    >
      <div className="size-full">
        <div className="flex flex-col items-center justify-center py-5">
          <i className="pi pi-lock p-8" style={{ fontSize: '3rem' }}></i>
          <div
            style={{
              borderRadius: '56px',
              padding: '0.3rem',
              background:
                'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)',
            }}
          >
            <div
              className="w-full px-8 py-8"
              style={{
                borderRadius: '53px',
                background: 'var(--surface-section)',
              }}
            >
              <div className="mb-8 text-center">
                <span className="text-lg font-bold leading-10 text-surface-600">
                  CHANGE PASSWORD
                </span>
              </div>

              <div>
                <ThemeProvider
                  colorMode={theme as 'light' | 'dark'}
                  theme={customTheme}
                >
                  <AccountSettings.ChangePassword
                    onSuccess={() => {
                      setOpen(false);
                      nav('/main/dashboard', {
                        viewTransition: true,
                      });
                    }}
                  ></AccountSettings.ChangePassword>
                </ThemeProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ChangePsPopup;
